
import { Vue, Component } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';

@Component({
  components: {
    Viewer,
  },
})
export default class VoucherImgDrawer extends Vue {
  visible = false;
  imgList = [];

  open(val: any) {
    this.visible = true;
    this.imgList = val;
  }

  close() {
    this.visible = false;
    this.imgList = [];
  }
}
